/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_New_Group_ButtonInputs */

const en_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Group`)
};

const fr_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau groupe`)
};

const de_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Gruppe`)
};

const it_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo gruppo`)
};

const ru_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новая группа`)
};

const es_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo grupo`)
};

const zh_cn2_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新集团`)
};

const ja_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいグループ`)
};

const hi_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया समूह`)
};

const pt_pt2_team_manager_new_group_button = /** @type {(inputs: Team_Manager_New_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo Grupo`)
};

/**
* | output |
* | --- |
* | "New Group" |
*
* @param {Team_Manager_New_Group_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_new_group_button = /** @type {((inputs?: Team_Manager_New_Group_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_New_Group_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_new_group_button(inputs)
	if (locale === "de") return de_team_manager_new_group_button(inputs)
	if (locale === "it") return it_team_manager_new_group_button(inputs)
	if (locale === "ru") return ru_team_manager_new_group_button(inputs)
	if (locale === "es") return es_team_manager_new_group_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_new_group_button(inputs)
	if (locale === "ja") return ja_team_manager_new_group_button(inputs)
	if (locale === "hi") return hi_team_manager_new_group_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_new_group_button(inputs)
	return en_team_manager_new_group_button(inputs)
});